import { Navigate, useParams, useSearchParams } from 'react-router-dom'
import { usePublicSignupSurvey } from '../api/public-signup-survey'
import { parseInstrumentLinkToken } from '../lib/instrument-link-url'
import { nonSignupSurveyEntryPath } from '../lib/instrument-link-routing'
import { isPublicSignupSurveyNotFound } from '../lib/signup-survey-welcome-copy'
import { InstrumentLinkLoadingView } from '../components/InstrumentLinkOnboardingViews'
import { InstrumentLinkOnboardingPage } from './InstrumentLinkOnboardingPage'
import { SignupSurveySharePage } from './SignupSurveySharePage'

/**
 * Public entry — `/instruments/:instrumentId` and `/instrument/:instrumentId`.
 * (`/instrument/:id/info` and `/survey` stay behind RequireAuth.)
 * - signup survey: existing welcome / token onboarding
 * - any other survey URL: logged-in providers start in the browser; logged-out providers hit login
 */
export function InstrumentPathEntryPage() {
  const { instrumentId } = useParams<{ instrumentId?: string }>()
  const [searchParams] = useSearchParams()
  if (instrumentId === 'onboarding') {
    return <InstrumentLinkOnboardingPage />
  }
  const token = parseInstrumentLinkToken(searchParams.toString())
  if (token) {
    return <LinkedSurveyEntry instrumentId={instrumentId} />
  }
  return <SignupSurveySharePage />
}

/** Invitation links (`?t=`) stay on signup onboarding; other surveys skip it. */
function LinkedSurveyEntry({ instrumentId }: { readonly instrumentId?: string }) {
  const query = usePublicSignupSurvey(instrumentId ? { instrumentId } : undefined)
  if (!instrumentId) {
    return <InstrumentLinkOnboardingPage />
  }
  if (query.isPending) {
    return <InstrumentLinkLoadingView />
  }
  if (query.isError && isPublicSignupSurveyNotFound(query.error)) {
    return <Navigate to={nonSignupSurveyEntryPath(instrumentId)} replace />
  }
  return <InstrumentLinkOnboardingPage />
}
